import Script from 'next/script';
import Head from 'next/head';
import { Box } from '@mui/material';
import { SliceZone, PrismicRichText } from '@prismicio/react';
import * as prismicH from '@prismicio/helpers';

import Footer from '@components/Footer';
import ExitIntent from '@components/ExitIntent';
import { createClient, linkResolver } from '../prismicio';
import { components } from '../slices';
import AnnouncementBanner from '@components/AnnouncementBanner';

const Page = ({ page, navigation, settings, pages }: any) => {
  const { data, first_publication_date, last_publication_date, type } =
    page || {};
  const herSection =
    data?.slices?.find((slice: any) => slice?.slice_type === 'hero_section') ||
    {};
  const { by_whom, dish_image } = herSection?.primary || {};

  const schema = {
    '@context': 'https://schema.org',
    headline: data.seo_title,
    author: {
      '@type': 'Person',
      name: by_whom,
      // The full URL must be provided, including the website's domain.
      //url: new URL(prismicH.asLink(article.data.author), 'https://example.com'),
    },
    image: prismicH.asImageSrc(dish_image),
    datePublished: first_publication_date,
    dateModified: last_publication_date,
  };

  return (
    <>
      <Head>
        <title>{page.data.seo_title}</title>
        <meta name="description" content={page.data.description} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      </Head>
      <AnnouncementBanner bgcolor="cinnamon.main" />
      <ExitIntent isAutoShowOnFiveSec />
      <PrismicRichText field={page.data.content} />
      <Box sx={{ position: 'relative' }}>
        <SliceZone
          slices={page.data.slices}
          components={components}
          context={{ pages, pageType: type, data }}
        />
      </Box>
      <Footer />
      <Script src="https://static.cdn.prismic.io/prismic.js?new=true&repo=thecuminclub" />
    </>
  );
};

export default Page;

export async function getStaticProps({ params, previewData }: any) {
  const client = createClient({ previewData });
  const receipePages = await client.getAllByType('page');
  const storyPages = await client.getAllByType('story');
  const fusionReceipePages = await client.getAllByType('fusion_receipe');
  const announcementPages = await client.getAllByType('announcement');

  const allPages = [
    ...receipePages,
    ...storyPages,
    ...announcementPages,
    ...fusionReceipePages,
  ];

  const page = allPages?.find((page: any) => page.uid === params.uid);

  const sameTypePage = allPages?.filter(
    (pageDetail: any) =>
      pageDetail?.type === page?.type && pageDetail.uid !== params.uid
  );

  return {
    props: {
      page,
      pages: sameTypePage,
    },
  };
}

export async function getStaticPaths() {
  const client = createClient();
  const receipePages = await client.getAllByType('page');
  const storyPages = await client.getAllByType('story');
  const fusionReceipePages = await client.getAllByType('fusion_receipe');
  const announcementPages = await client.getAllByType('announcement');

  const allPages = [
    ...receipePages,
    ...storyPages,
    ...announcementPages,
    ...fusionReceipePages,
  ];

  return {
    paths: allPages.map((page) => prismicH.asLink(page, linkResolver)),
    fallback: false,
  };
}
